<template>
  <div
    class="field"
    :class="additionalClasses"
  >
    <label :for="_uid">{{ label }}</label>
    <p
      v-if="additionalInfo"
      style="margin-bottom: 5px"
      v-html="additionalInfo"
    />
    <ValidationProvider
      v-slot="{ validate, errors }"
      :rules="rules"
    >
      <textarea
        :id="_uid"
        :placeholder="placeholder"
        :value="value"
        :class="{'error': errors.length}"
        :rows="rows"
        @blur="validate"
        @input="$emit('input', $event.target.value), validate($event)"
      />
      <div v-if="errors.length" class="error__text">
        {{ errors[0] }}
      </div>
      <div v-if="lineCountWarning">
        <p style="margin-top: 5px">
          {{ lineCountWarning }}
        </p>
      </div>
      <div v-if="wordCountWarning">
        <p style="margin-top: 5px">
          {{ wordCountWarning }}
        </p>
      </div>
      <div v-if="characterCountWarning">
        <p style="margin-top: 5px">
          {{ characterCountWarning }}
        </p>
      </div>
    </ValidationProvider>
    <pre style="display: none">{{ value }}</pre>
  </div>
</template>

<script>
import usesValidation from '@/mixins/veeValidate'
export default {

  name: 'DSTextArea',

  mixins: [usesValidation],

  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: 'required|max:500',
    },
    value: {
      type: String,
      default: '',
    },
    rows: {
      type: String,
      default: '4',
    },
    additionalInfo: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },

  computed: {
    additionalClasses() {
      return {
        required: this.required,
      }
    },
    wordCount() {
      return this.value.split(/\b\w+\b/).length - 1
    },
    characterCount() {
      return this.value.length
    },
    rowCount() {
      return this.value.split(/\r\n|\r|\n/).filter((n) => n != "").length
    },
    maxWords() {
      const maxWordsLimit = this.rules.match(/maxWords:(\d+)/);
      return maxWordsLimit ? parseInt(maxWordsLimit[1], 10) : Infinity;
    },
    maxCharacters() {
        const maxCharactersLimit = this.rules.match(/max:(\d+)/);
        return maxCharactersLimit ? parseInt(maxCharactersLimit[1], 10) : Infinity;
    },
    maxLines() {
      const maxLinesLimit = this.rules.match(/maxLines:(\d+)/);
      return maxLinesLimit ? parseInt(maxLinesLimit[1], 10) : Infinity;
    },
    lineCountWarning() {
      if (!this.rules.includes('maxLines:')) {
        return null;
      }
      if (this.rowCount == 0 ) {
        return null
      }
      const linesRemaining = this.maxLines - this.rowCount;
      if (linesRemaining < 0) {
        return null;
      }
      return `${linesRemaining} lines remaining`;
    },
    wordCountWarning() {
      if (!this.rules.includes('maxWords:')) {
        return null;
      }
      if (this.wordCount == 0 ) {
        return null
      }
      const wordsRemaining = this.maxWords - this.wordCount;
      return `${wordsRemaining} words remaining`;
    },
    characterCountWarning() {
      if(!this.rules.includes('max:')){
        return null;
      }
      if (this.characterCount == 0 ) {
        return null
      }
      const charactersRemaining = this.maxCharacters - this.characterCount;
      return `${charactersRemaining} characters remaining`;
    },

  },
}
</script>

<style lang="css" scoped>
  .field {
    width: 100%;
  }
</style>
